import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { addressesApi } from '../services/api';

export function useCheckoutGate() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showGateModal, setShowGateModal] = useState(false);

  const handleCheckoutClick = async () => {
    if (user) {
      try {
        const addresses = await addressesApi.getAll();
        if (addresses.length > 0) {
          navigate('/checkout');
        } else {
          setShowGateModal(true);
        }
      } catch {
        setShowGateModal(true);
      }
    } else {
      const guestAddress = sessionStorage.getItem('orderflow_guest_address');
      if (guestAddress) {
        navigate('/checkout');
      } else {
        setShowGateModal(true);
      }
    }
  };

  const handleGateComplete = async (addressObject) => {
    if (user) {
      try {
        await addressesApi.add({ ...addressObject, is_default: true });
      } catch (err) {
        console.error('Failed to save address:', err);
      }
    } else {
      sessionStorage.setItem('orderflow_guest_address', JSON.stringify(addressObject));
    }
    setShowGateModal(false);
    navigate('/checkout');
  };

  return { showGateModal, setShowGateModal, handleCheckoutClick, handleGateComplete };
}
